import React from 'react';
import { useStoreSelector } from 'v3/data/store';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import Footer from 'v3/shared/components/Footer';
import { NavBar } from 'v3/shared/components/NavBar';
import { OnlineNavBar } from 'v3/shared/components/OnlineNavBar';
import { TemplateBody, TemplateContainer } from 'v3/shared/templates/styles';
import { IDefaultTemplate } from './types';

export const CommonTemplate = ({ children }: IDefaultTemplate) => {
  const { group } = useStoreSelector((store) => store.store.storeLogged);
  const isOnlineProfile
    = group === StoreProfileEnum.IN_APP
    || group === StoreProfileEnum.LOM
    || group === StoreProfileEnum.ONLINE;
  return (
    <TemplateContainer>
      {isOnlineProfile ? <OnlineNavBar /> : <NavBar />}
      <TemplateBody>{children}</TemplateBody>
      <Footer />
    </TemplateContainer>
  );
};
